import { render } from "./categoryAdvertisingProgram.vue?vue&type=template&id=232ab432"
import script from "./categoryAdvertisingProgram.vue?vue&type=script&lang=js"
export * from "./categoryAdvertisingProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__